import React, {Component} from 'react';
import {Item} from 'semantic-ui-react';
import ProductGroup from "../ProductGroup";
import OverviewTable from "../OverviewTable";

export default class ProductList extends Component {


    render() {

        if(this.props.products.length > 100){
            return (<div>
                <OverviewTable products={this.props.products}/>
            </div>);
        }
        let group = this.groupBy(this.props.products, 'parent_id');
        return (

            <div>
                <Item.Group divided>
                    {this.props.products && Object.keys(group).map((id) => {
                        return <ProductGroup picture={Object.keys(group).length < 5 } group={group[id]} groupID={id} key={id}/>
                    })}
                </Item.Group>
            </div>
        );
    }

    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };
}




// WEBPACK FOOTER //
// ./src/scenes/Inventory/components/ProductList/index.js